const jobs = {
  reservations: 'Reservas',

  btnCreate: 'Crear',
  btnRoute: 'Ruta',

  createHeaderTitle: 'Crear',
  updateHeaderTitle: 'Actualizar',

  import: {
    title: 'Importar Reservas',
  },

  toast: {
    error: {
      create: {
        badResponse: 'Ocurrió un error al crear la reserva',
      },
      edit: {
        badResponse: 'Ocurrió un error al actualizar la reserva',
      },
      find: {
        badResponse: 'No se pudo encontrar los Shuttlees ',
      },
    },

    success: {
      create: {
        default: 'La reserva ha sido creada correctamente',
      },

      update: {
        default: 'La reserva se ha actualizado correctamente',
      },
    },

    group: {
      success: 'La reserva ha sido agrupada correctamente',
      failure: {
        privateOnly: 'No pudimos agrupar estas reservas porque algunas de ellas están configuradas para ser solo privadas.',
        unknownError: 'Agrupar estas reservas encontró un problema inesperado. Intente de nuevo o comuníquese con nuestro soporte.',
      },
    },

    ungroup: {
      success: 'La reserva se ha desagrupado correctamente',
    },

    blockWaitAndReturn: {
      success: 'La reserva se ha desactivado correctamente de espera y vuelta',
    },

    unblockWaitAndReturn: {
      success: 'La reserva se ha habilitado correctamente para la espera y la vuelta',
    },
  },

  toolTip: {
    routingCancelJob: 'Al menos un trabajo no tiene el estado nuevo',
    atLeastOneLockedJob: 'Al menos un trabajo está bloqueado',
    noPermission: ' Sin permisos',
    atLeastOneStatusNotNew: 'Al menos un trabajo no está en estado nuevo',
    dataSync: 'La sincronización de datos está en curso',
  },

  create: {
    confirmButtonText: 'Enviar',
    successModal: {
      header: 'Éxito',
      body: '¡Reserva creada!',
    },

    errorModal: {
      header: 'Ocurrió un error',
      body: 'No se pudo crear la reserva',
    },

    confirmationModal: {
      header: 'Confirmar reserva',
      subtitle: 'Por favor, lea el guión a continuación - Palabra por palabra - ¡No se apresure!',
      content:
        'Tenemos {{service}} reserva para {{seats}} persona\nEl {{date}} de {{from}} a {{to}}\n\n¿Es correcto? ¡Genial!\n\nEl precio es {{price}}\nGracias por llamar al {{company}}',
      table: {
        headers: {
          details: 'Detalles de la expedición',
          fare: 'Tarifa',
        },

        fields: {
          details: {
            pickAdrs: 'Dirección de Recogida',
            dropAdrs: 'Dirección de Deja',
            pickTime: 'Hora de Recogida',
            seats: 'Adultos',
          },
          fare: {
            service: 'Servicio',
          },
        },
      },
      bottomLine: 'Precio total',
    },
    serviceTable: {
      columns: {
        name: 'Nombre',
        maxPax: 'Máx. De pasajeros',
      },
    },
    duplicateJobsModal: {
      body: 'Tenga en cuenta que hay otras reservas con exactamente los mismos detalles. ¿Desea continuar?',
      btnConfirm: 'Si',
      btnClose: 'No',
    },
  },

  payments: {
    table: {
      headers: {
        createdBy: 'Creado',
        email: 'Correo electrónico del usuario del originador',
        amount: 'Cantidad',
        type: 'Tipo',
        ccMasked: 'CC enmascarado',
        status: 'Estado',
        refNum: 'Núm. De referencia ',
      },
    },

    paymentsDetails: {
      title: 'Detalles',

      status: {
        charged: 'Cargado:',
        pending: 'Pendiente:',
        declined: 'Rechazado:',
        variance: 'Variación:',
      },
    },

    addPaymentForm: {
      title: 'Añadir pago',

      fields: {
        amount: 'Cantidad',
        paymentType: 'Tipo de pago',
        cardNum: 'Número de crédito',
        cardExp: 'Expira',
        cvv: 'CVV',
        paymentOptions: {
          select: 'Seleccionar',
          credit: 'Crédito',
          directBill: 'Factura directa',
          card: 'La tarjeta',
          expDate: 'Fecha de vencimiento',
        },
      },

      validations: {
        price: 'El precio debe ser mayor que cero',
      },

      confirmPaymentBtn: 'Confirmar pago',
      modalSuccess: {
        header: '¡Éxito!',
        body: '¡El pago se realizó correctamente!',
      },

      modalError: {
        header: '¡Ocurrió un error!',
        body: 'El pago falló. Intente de nuevo',
      },
    },
  },

  update: {
    title: 'Número de reserva {{id}}',
    confirmButtonText: 'Enviar',

    successModal: {
      header: 'Éxito',
      body: '¡Reserva actualizada!',
    },

    errorModal: {
      header: 'Ocurrió un error',
      body: 'No se pudo actualizar la reserva',
    },

    formTabs: {
      summary: 'Resumen',
      edit: 'Editar',
      payments: 'Pagos',
      notes: 'Notas',
      history: 'Historia',
    },

    summary: {
      driver: 'Conductor',
      vehicle: 'Vehículo',
      tripId: 'ID de expedición',
      tripStatus: 'Estado de la expedición',
      RPTime: 'Hora de recogida solicitada',
      MPTime: 'Hora de recogida de Moovex',
      PETA: 'Tiempo estimado de llegada (ETA)',
      PR: 'Retirada reportada (conductor)',
      DR: 'Regreso reportado (conductor)',
      empty: 'No disponible',
      notAssigned: 'No asignado',
      notRouted: 'No enrutado',
      attributes: 'Atributos',
      noShow: 'No apareció',
      supplier: 'Proveedor',
    },
    jobNotSupported: 'El tipo de reserva no es compatible',
  },

  bulk: {
    select: 'Seleccionar',
    toasts: {
      createdSuccessfully: '¡Reserva creada!',
    },

    errorModal: {
      header: 'Ocurrió un error',
      body: 'No se pudo crear la reserva',
    },

    table: {
      direction: {
        to: 'Distribuir',
        from: 'Recoger',
        both: 'Recoger/Distribuir',
      },
    },

    direction: {
      label: 'Dirección',
      to: 'Hacia',
      from: 'De',
      both: 'AMbos',
    },

    dateMode: {
      automated: 'Programación automática',
      manual: 'Selección manual de hora',
    },

    form: {
      information: {
        details: {
          header: 'Detalles',
          fields: {
            shift: 'Turno',
            from: 'De',
            to: 'Hacia',
            fromDate: 'De fecha',
            toDate: 'Hasta la fecha',
            weekDays: 'Días de la semana',
            fromHour: 'De Hora',
            toHour: 'A Hora',
            requestPickup: 'Hora de recogida solicitada',
            requestDropoff: 'Hora de deja solicitada',
            direction: 'Seleccionar dirección',
            dateMode: 'Preferencia de tiempo',
          },
        },
        locations: {
          header: 'Ubicaciones',
          fields: {
            locations: 'Seleccionar ubicación',
          },
        },
        dateMode: {
          header: 'Preferencia de tiempo',
          label: 'Seleccionar preferencia de tiempo',
        },
      },
    },
  },

  routeSummary: {
    reservations: 'Reservas',
    trips: 'Viajes',
    assigned: 'Asignado',
    unassigned: 'Sin asignar',
    tripsAssigned: 'Viajes asignados',
    vehicles: 'Vehículos',
    workingTime: 'Tiempo de trabajo',
    drivingTime: 'Tiempo de conducción',
    miles: 'Millas',
    routingProcessTime: 'Tiempo del proceso de ruteo',
  },

  headerButtons: {
    create: {
      new: 'Nuevo',
      quick: 'Rápido',
      bulk: 'Multiples',
      shuttle: 'Shuttle',
      import: 'Importar',
      normal: 'Normal',
      schoolBooking: 'Reserva escolar',
      workplaceBooking: 'Reserva laboral',
    },

    import: 'Importar',

    route: {
      route: 'Ruta',
      routeAndAssign: 'Ruteo y asignación',
    },

    moreActions: {
      button: 'Más',
      options: {
        cancelModal: {
          title: 'Cancelar reservas',
          reasonInputPlaceholder: 'Introduzca el motivo de la cancelación.',
          contentSingular: 'Está a punto de cancelar 1 reserva.',
          contentPlural: 'Está a punto de cancelar {{count}} reservas.',
          confirmButton: 'Confirmar',
          success: 'Las reservas se cancelaron correctamente',
        },
        deleteModal: {
          title: 'Eliminar Reservas',
          body: 'Está a punto de eliminar {{count}} reservas',
          success: 'Las reservas se eliminaron correctamente',
        },
        releaseRouting: {
          label: 'Versión de ruta',
        },
        manualRouteModal: {
          title: 'Manual Route',
          toolTip: {
            header: 'Drag and drop your selected bookings to arrange them in the desired trip order',
          },
          removeModal: {
            title: 'Eliminar Reservaciones',
            body: 'You are about to remove 1 Booking',
            confirmButton: 'Confirmar',
          },

          durationExceeds: {
            title: 'Atención - La duración del viaje excede las 24 horas',
            body: 'La duración del viaje que estás a punto de planificar contiene reservaciones con una diferencia de tiempo que excede las 24 horas. ¿Estás seguro de que deseas continuar?',
            confirmButton: 'Confirmar',
          },
        },
      },
    },
  },

  advancedRoutingModal: {
    all: 'Todo',
    RouteBodyText: 'Está a punto de enrutar {{num}} reservas.',
    RouteAssignBodyText: 'Está a punto de enrutar y asignar {{num}} reservas.',
    advancedSettings: 'Avanzado',
    noJoin: 'No Unir',
    joinOptions: {
      noJoin: 'No Unir',
      tryJoin: 'Intentar Unir',
      onlyJoin: 'Solo Unir',
    },
    clusterSettings: 'Configuración de Cluster',
    assignSettings: 'Configuración de asignación de conductores',
    routeJobs: 'Enrutar reservas',
    routeAssignJobs: 'Enrutar y asignar reservas',
    advancedRoutingSettings: 'Configuración de ruteo avanzada',
    mainParameters: 'Configuración de ruteo avanzada',
    ratio: 'Ratio',
    ratioInfo:
      '1.5 significa que la duración de una persona sentada en el vehículo no excede el 150% del tiempo que habría estado conduciendo sola.',
    pax: 'Máx. Pasajeros',
    paxInfo: 'Cantidad máxima de lugares por viaje',
    maxDuration: 'Duración máxima',
    maxDurationInfo: 'Duración máxima de un viaje',
    maxStops: 'Paradas Máx.',
    maxStopsInfo: 'Máximo de paradas en un viaje',
    pickSeconds: 'Tiempo de Embarque',
    pickSecondsInfo:
      'Tiempo de embarque calculado. Se prolongará la duración total del viaje. Los tiempos serán añadidos a la matriz de "espera" para esta parada.',
    dropSeconds: 'Hora de deja ',
    dropSecondsInfo:
      'Tiempo de salida calculado del trabajo. Se prolongará la duración total del viaje. Los tiempos serán añadidos a la matriz de "espera" para esta parada.',
    pickGapAfter: 'Máx. Atraso',
    pickGapAfterInfo: 'La hora de recogida de un trabajo no será más de 30 minutos después de la hora de recogida de otro trabajo.',
    pickGapBefore: 'Máx. Temprano',
    pickGapBeforeInfo: 'La hora de retirar un trabajo no precederá a la hora de retirar otro trabajo en más de 30 minutos.',
    airKMPH: 'KMPH del aire',
    airKMPHInfo: 'Comuníquese con soporte',
    allowLate: 'Permitir atraso',
    allowLateInfo: 'Comuníquese con soporte',
    maxPrice: 'Precio máximo',
    maxPriceInfo: 'Comuníquese con soporte',
    maxTrips: 'Viajes máximos',
    maxTripsInfo: 'Asistencia máxima de viajes',
    shiftMaxMinutes: 'Turno máximo de minutos',
    shiftMaxMinutesInfo: 'Comuníquese con soporte',

    routeTemplates: 'Plantillas de ruta',
    assignTemplates: 'Asignar plantillas',

    form: {
      validation: {
        mustBeHigher: 'Debe ser {{val}} o mayor',
      },
    },
  },

  clusters: {
    clusterRadius: 'Diámetro del Cluster',
    snapTo: 'Modo',
    none: 'Ninguno',
    both: 'Ambos',
    to: 'Hacia',
    from: 'De',
    address: 'Dirección',
    bus: 'Estación de autobús',
  },

  forms: {
    header: {
      createNewRservationTitle: 'Nueva reserva',
      updateReservationTitle: 'Reserva',

      createNormalRservation: {
        subTitle: 'Normal',
      },

      createQuickRservation: {
        subTitle: 'Rápido',
      },

      createShuttleRservation: {
        subTitle: 'Shuttle',
      },
    },

    roundTrip: 'Viaje de ida y vuelta',
    oneWay: 'Sentido Unico',
    information: {
      details: {
        header: 'Detalles del perfil',
        fields: {
          site: 'Sitio',
          profile: 'Perfil',
        },
      },
      jobDetails: {
        flightTypes: {
          international: 'Internacional',
          domestic: 'Nacionales',
          customerRequest: 'Solicitud del cliente',
        },
        fareBreakdown: 'Desglose de tarifa',
      },
      linkedPassengers: {
        header: 'Pasajeros vinculados',
        searchPlaceholder: 'Buscar',
      },
      reservationDetails: {
        header: 'Detalles de la reserva',
        fields: {
          from: 'De',
          to: 'Hacia',
          terminal: 'Terminal',
          seats: 'Asientos',
          checkedBags: 'Bolsos Registrados',
          switchADA: 'ADA',
          wheelchair: 'Silla de ruedas',
          adults: 'Adultos',
          infants: 'Lactantes',
          carryon: 'Carrito',
        },
        clearBtn: 'Borrar',
      },
      flightDetails: {
        header: 'Información del Vuelo',
        flightAirline: 'Aerolínea',
        flightNumber: 'Número de Vuelo',
        scheduledFlightTime: 'Hora Programada del Vuelo',
        actualFlightTime: 'Hora Real del Vuelo',
        flightStatus: 'Estado del Vuelo',
      },
      caregiverInformation: {
        header: 'Información del cuidador',
        fields: {
          firstName: 'Nombre',
          lastName: 'Apellido',
          address: 'Dirección',
          phone: 'Telefono',
        },
      },
      serviceAndTime: {
        header: 'Servicio y tiempo',
        fields: {
          scheduleBy: 'Programación por',
          dateTime: 'Fecha y hora',
          service: 'Servicio',
          switchRecurring: 'Recurrente',
          attributes: 'Atributos',
          repeatEvery: 'Repetir cada',
          ends: 'Termina',
          never: 'Nunca',
          on: 'En',
          after: 'Después',
          occurrences: 'Ocurrencias',
        },
        buttons: {
          now: 'Ahora',
        },
      },
      personalInfo: {
        header: 'Información personal',
        fields: {
          email: 'Correo electrónico',
          fullName: 'Nombre completo',
          firstName: 'Nombre',
          lastName: 'Apellido',
          phone: 'Telefono',
          address: 'Dirección',
          specialIdentifier: 'Identificador especial',
        },
      },
      billingInfo: {
        sameAsPersonalInformation: 'Igual que la información personal',
        header: 'Información de facturación',
        fields: {
          country: 'Pais',
          state: 'Estado',
          zip: 'Código postal',
        },
      },
      payments: {
        header: 'Pagos',
        fields: {
          price: 'Precio',
          paymentSelect: {
            header: 'Tipo de pago',
            options: {
              credit: 'Crédito',
              directBill: 'Factura directa',
            },
          },
          cardNum: 'Número de crédito',
          cardExp: 'Expira',
          cvv: 'CVV',
        },
      },
      additionalFields: {
        header: 'Campos adicionales',
        fields: {
          driver: 'Conductor',
          car: 'Cochera',
          waitMinutes: 'Minutos de espera',
        },
      },
      notes: {
        header: 'Notas',
      },
      profile: {
        header: 'Perfil',
        label: 'Seleccionar perfil',
      },
      passengers: {
        header: 'Información personal',
        label: 'Seleccionar pasajeros',
      },
      attributes: {
        header: 'Atributos',
        label: 'Seleccionar atributos',
      },
      supplier: {
        header: 'Proveedor',
      },
    },
    validations: {
      unit: {
        required: 'El perfil es obligatorio',
      },
      amount: {
        required: 'La cantidad es obligatoria',
      },
      from: {
        required: 'De es obligatorio',
      },
      direction: {
        required: 'Se requiere dirección',
      },
      to: {
        required: 'Hacia es obligatorio',
      },
      type: {
        required: 'Obligatorio',
      },
      email: {
        message: 'Introduzca un correo electrónico válido',
        required: 'El correo electrónico es obligatorio',
      },
      firstName: {
        conditions: {
          min: 'El nombre debe tener un mínimo de 2 caracteres',
          max: 'El nombre debe tener un máximo de 30 caracteres',
        },
        required: 'El nombre es obligatorio',
      },
      lastName: {
        conditions: {
          min: 'El apellido debe tener un mínimo de 2 caracteres',
          max: 'El apellido debe tener un máximo de 30 caracteres',
        },
        required: 'Apellido es obligatorio',
      },
      phone: {
        message: 'El número de teléfono no es válido',
        required: 'El número de teléfono es obligatorio',
      },
      price: {
        message: 'El precio debe ser un número',
        required: 'El precio es obligatorio',
      },
      flightTerminal: {
        required: 'La terminal de vuelo es obligatoria',
      },
      adults: {
        required: 'Se requieren adultos',
      },
      seats: {
        required: 'Los lugares son obligatorios',
      },
      infants: {
        required: 'Los bebés son obligatorios',
      },
      carryon: {
        required: 'Cargar es obligatorio',
      },
      paymentType: {
        required: 'El tipo de pago es obligatorio',
      },
      cardNum: {
        required: 'El número de tarjeta es obligatorio',
      },
      cardExp: {
        required: 'La fecha de vencimiento de la tarjeta es obligatoria',
      },
      cvv: {
        required: 'Se requiere CVV',
      },
      profile: {
        required: 'El perfil es obligatorio',
      },
      fare: {
        required: 'La tarifa es obligatoria',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
        delete: 'Eliminar',
      },
    },
  },

  table: {
    footer: {
      totalSeats: 'Total de asientos: {{seats}}',
    },
    actions: {
      delete: 'Eliminar',
      export: 'Exportar',
      route: 'Ruta',
      cancel: 'Cancelar',
      routeAndAssign: 'Ruteo y Asignación',
      group: 'Agrupar',
      ungroup: 'Desagrupar',
      blockWaitAndReturn: 'Deshabilitar Esperar y Regresar',
      unblockWaitAndReturn: 'Habilitar Esperar y regresar',
      releaseRouting: 'Versión de ruta',
      sendToBid: 'Enviar a licitación',
      estimateWillCalls: 'Estimar Will Calls',
      tooltips: {
        estimateWillCallsDisabled: 'Al menos un trabajo no está en estado “nuevo”'
      }
    },
    cells: {
      car: {
        none: 'Sin vehículo',
      },
      driver: {
        none: 'Sin conductor',
      },
      supplier: {
        none: 'Sin Proveedor',
      },
    },
    filters: {
      status: 'Estado',
      profile: 'Perfiles',
      supplier: 'Proveedores',
      attributes: 'Atributos',
      flightNumber: 'Número de Vuelo',
      airline: 'Aerolínea',
      flightStatus: 'Estado del Vuelo',
      drivers: 'Conductores',
      vehicles: 'Vehículos',
      from: 'De',
      to: 'Hacia',
      locations: 'Ubicaciones',
      airportLocations: 'Ubicaciones de Aeropuerto',
      areas: 'Zonas',
    },
    headers: {
      externalID: 'ID externo',
      flightInfo: 'Información del Vuelo',
      id: 'ID',
      io: 'I&O',
      returnTrip: 'Viaje de Regreso',
      legA: 'Tramo A',
      legB: 'Tramo B',
      seats: 'Asientos',
      driver: 'Conductor',
      vehicle: 'vehículo',
      from: 'De',
      to: 'Hacia',
      supplier: 'Proveedor',
      statusAndId: 'ID',
      passenger: 'Pasajero',
      indicators: 'Indicadores',
      attributes: 'Atributos',
      extendUntilDate: 'Espere hasta',
      date: 'Date',
      phone: 'Phone',
      flightNumber: 'Número de Vuelo',
      email: 'Email',
      service: 'Service',
      airline: 'Aerolínea',
      scheduledFlightTime: 'Hora Programada del Vuelo',
      actualFlightTime: 'Hora Real del Vuelo',
      flightStatus: 'Estado del Vuelo',
      price: 'Price',
      profile: 'Profile',
      areas: 'Zonas',
      distance: 'Distancia',
      duration: 'Duración',
      cost: 'Costo',
    },
    statuses: {
      new: 'Nuevo',
      onHold: 'En espera',
      canceled: 'Cancelado',
      routing: 'Ruteo',
      routed: 'Ruteado',
      picked: 'Recogido',
      dropped: 'Dejado',
      noshow: 'No apareció',
    },
    labels: {
      grouped: 'Agrupados',
      waitAndReturn: 'Espera y vuelve',
      roundTrip: 'Bidireccional',
      arrivalTime: {
        label: 'Hora de llegada',
        tooltip: 'Hora de llegada',
      },
    },
  },

  assignVehiclesDrivers: {
    routeSummaryModal: {
      header: 'Resumen de ruta',
    },
  },

  checkRouteStatus: {
    routeSummaryModal: {
      header: 'Resumen de ruta',
    },
  },
  shuttleReservation: {
    create: {
      confirmButtonText: 'Reservar',
    },

    form: {
      information: {
        recurring: {
          header: 'Recurrente',
        },
        personalInformation: {
          header: 'Detalles personales',
          fields: {
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Correo electrónico',
            phone: 'Telefono',
          },
        },
        paymentOption: {
          header: 'Opciones de pago',
          fields: {
            paymentType: 'Tipo de pago',
            cardNum: 'NÚMERO DE CARTA',
            cardExp: 'Expira',
            cvv: 'CVV',
            rate: 'Tasa',
            amount: 'Cantidad',
            fare: 'Tarifa',
          },
          paymentTypes: {
            free: 'Libre',
            opuscard: 'Tarjeta opus',
            cashonboard: 'Efectivo a Bordo',
            creditcard: 'Tarjeta de crédito',
            correspondance: 'Correspondencia',
          },
          rateTypes: {
            ordinary: 'Cantidad en efectivo',
            reduced: 'Reducido',
          },
        },
        bookingDetails: {
          header: 'Detalles de la reserva',
          fields: {
            supplier: 'Proveedor',
            date: 'Fecha',
            hour: 'Hora',
            area: 'Zona',
            direction: 'Dirección',
            operationHours: 'Horas de operación',
            line: 'Shuttle',
            pickup: 'Retirada',
            dropoff: 'Deja',
            seats: 'Asientos',
          },
        },
      },
      validations: {
        drivers: {
          required: 'Se requieren conductores',
        },
        area: {
          required: 'El zona es obligatoria',
        },
        direction: {
          required: 'Se requiere dirección',
        },
        unit: {
          required: 'La unidad es obligatoria',
        },
        supplier: {
          required: 'El proveedor es obligatorio',
        },
        driver: {
          required: 'El conductor es obligatorio',
        },
        start: {
          required: 'La fecha de inicio es obligatoria',
        },
        end: {
          required: 'La fecha de finalización es obligatoria',
        },
        firstName: {
          required: 'El nombre es obligatorio',
        },
        lastName: {
          required: 'Apellido es obligatorio',
        },
        email: {
          required: 'El correo electrónico es obligatorio',
        },
        phone: {
          required: 'El teléfono es obligatorio',
        },
        date: {
          required: 'La fecha es obligatoria',
        },
        line: {
          required: 'Se requiere un Shuttle',
        },
        hour: {
          required: 'La hora es obligatoria',
        },
        from: {
          required: 'De es obligatorio',
        },
        fromLat: {
          required: 'Latitude inicial es obligatoria',
        },
        fromLon: {
          required: 'Longitud inicial es obligatoria',
        },
        to: {
          required: 'Hacia es obligatorio',
        },
        toLat: {
          required: 'Latitud final es obligatoria',
        },
        toLon: {
          required: 'Latitud final es obligatoria',
        },
        seats: {
          required: 'Los lugares son obligatorios',
          conditions: {
            min: 'Los lugares deben ser más altos que {{min}}',
          },
        },
        paymentOptions: {
          required: 'Las opciones de pago son obligatorias',
          paymentType: {
            required: 'El tipo de pago es obligatorio',
          },
          data: {
            required: 'Los datos de pago son obligatorios',
            opusCard: {
              minLength: 'Debe tener exactamente 12 caracteres',
            },
          },
        },
      },
    },

    toasts: {
      notFound: 'No se encontró Shuttle para este día',
    },
  },
  duplicatedCreationModal: {
    header: 'Duplicar reserva: ¿Continuar?',
    body: 'Hay otras reservas con detalles idénticos. ¿Desea continuar con la creación de la reserva?',
  },

  duplicatedUpdatingModal: {
    header: 'Duplicar reserva: ¿Continuar?',
    body: 'Hay otras reservas con detalles idénticos. ¿Desea continuar con la actualización de la reserva?',
  },

  modals: {
    groupModal: {
      header: 'Agrupar Reservas',
      body: 'Está a punto de agrupar {{count}} reservas',
      btnConfirm: 'Confirmar',
    },
    confirmGroupModal: {
      header: 'Agrupar Reservas',
      body: 'Una de las reservas ya está agrupada. ¿Desea continuar y reagruparlo?',
    },
    unGroupModal: {
      header: 'Desagrupar reservas',
      body: 'Está a punto de desagrupar {{count}} reservas',
      btnConfirm: 'Confirmar',
    },
    blockedGroupModal: {
      header: 'Agrupar o desagrupar reservas',
      body: 'La acción de Agrupar o Desagrupar solo se permite en las reservas con el estado "Nuevo"',
      btnConfirm: 'Cerrar',
    },
  },
};

export default jobs;
